import { DataContext } from "../DataContext";
import { useContext } from "react";
import styled from "styled-components";
import { renderSizeAbbreviationHTML } from "../utils";
import Form from "react-bootstrap/Form";
import { ASSET_URL } from "../constants";
import { Button } from "../styles";

const ProductRow = styled.div`
  display: flex;
  position: relative;
  overflow: hidden;
  background-color: var(--white);
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  padding: 20px 20px 97px;
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  & > a {
    width: auto;
  }
  .product-image {
    width: 100px;
    height: 100px;
    margin-right: 30px;
    img {
      max-width: 90px;
      max-height: 90px;
    }
  }
  .product-options {
    flex-grow: 1;
    line-height: 200%;
    & > div {
      display: flex;
      span {
        margin-right: 20px;
      }
      strong {
        font-weight: 700;
      }
    }

    @media only screen and (max-width: 767px) {
      & > div {
        display: flex;
        justify-content: space-between;
        strong {
          font-weight: 700;
        }
        &.size,
        &.placement,
        &.unit-price {
          position: relative;
          span,
          strong {
            z-index: 1;
            background-color: var(--white);
          }
          span {
            padding-right: 10px;
            text-align: left;
          }
          strong {
            padding-left: 10px;
            text-align: right;
          }
          &::after {
            border: 1px dashed #dddddd;
            content: "";
            top: 50%;
            width: 100%;
            height: 1px;
            right: 0;
            display: block;
            position: absolute;
            z-index: 0;
          }
        }
      }
    }

    @media only screen and (min-width: 768px) {
      display: flex;
      justify-content: space-around;
      align-items: center;
      & > div.size,
      & > div.placement,
      & > div.unit-price {
        flex-direction: column;
        span,
        strong {
          text-align: center;
          margin-right: 0;
        }
      }
    }
  }
  .cartQuantity {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute !important;
    bottom: 0;
    background-color: var(--off-white);
    color: var(--dark-grey);
    border-top: 1px solid var(--border);
    width: 100%;
    left: 0;
    span {
      margin-right: 10px;
      width: initial !important;
    }
    select {
      padding: 8px 15px;
    }
  }
  @media only screen and (min-width: 992px) {
    padding: 20px 30px 97px;
    .product-image {
      width: 150px;
      height: 150px;
      img {
        max-width: 140px;
        max-height: 140px;
      }
    }
  }
`;

function CartProduct(props) {
  const { availableProducts, updateQuantityFromCart, deleteFromCart } = useContext(DataContext);
  const { productId, itemId, quantity, size, position, design } = props.product;

  const product = availableProducts.find((product) => {
    return productId === product.productId;
  });

  if (!product) return null;

  return (
    <ProductRow>
      <div className="product-image border">
        <picture>
          <source srcset={`${ASSET_URL}/designs/small/${design}-logo.avif`} type="image/avif" />
          <img src={`${ASSET_URL}/designs/small/${design}-logo.gif`} width="140" />
        </picture>
      </div>
      <div className="product-options">
        <div className="size">
          <span>Shirt Size</span>
          <strong className="size-badge" dangerouslySetInnerHTML={{ __html: renderSizeAbbreviationHTML(size) }} />
        </div>
        <div className="placement">
          <span>Placement</span>
          <strong>{position}</strong>
        </div>
        <div className="unit-price">
          <span>Unit Price</span>
          <strong>${product.cost}</strong>
        </div>
        <div className="cartQuantity box-padding-2030">
          <Form.Select
            name="quantity"
            id="quantity"
            className="quantity"
            value={quantity}
            onChange={(e) => updateQuantityFromCart(itemId, Number(e.target.value))}
            aria-label="quantity"
          >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </Form.Select>
          <Button className="textWithIcon" onClick={() => deleteFromCart(itemId)}>
            <i className="fa-solid fa-xmark"></i> remove from bag
          </Button>
        </div>
      </div>
    </ProductRow>
  );
}

export default CartProduct;
